export default __webpack_public_path__ + "static/auto@2x-1a18c3eead08eb0751774fc0e8bf28cc.jpg";